@if (!!value || showFieldAsEdit) {
  <div
    class="field"
    >
    <label class="upper">{{ displayName }}</label>
    @if (showFieldAsEdit) {
      <div>
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          <div
            style="width: 50px"
            class="body-small-500">
            {{ 'MAP.URL-NAME' | translate }}
          </div>
          <div>
            <input
              [(ngModel)]="name"
              (ngModelChange)="onValueChanged()"
              class="input is-small"
              type="text"
              placeholder="{{ 'MAP.URL-NAME' | translate }}" />
          </div>
        </div>
        <div
          class="mt-1"
          fxLayout="row"
          fxLayoutAlign="start center">
          <div
            style="width: 50px"
            class="body-small-500">
            {{ 'MAP.URL-URL' | translate }}
          </div>
          <div>
            <input
              [(ngModel)]="url"
              (ngModelChange)="onValueChanged()"
              class="input is-small"
              type="text"
              placeholder="{{ 'MAP.URL-URL' | translate }}" />
          </div>
        </div>
      </div>
    } @else {
      @if (url) {
        <div>
          <a
            [attr.href]="url"
            target="_blank">
            {{ name || url }}
          </a>
        </div>
      } @else {
        <div>---</div>
      }
    }
  </div>
}
